export default {
  namespaced: true,
  state: {
    // null means "use the company baseline zone"
    timezone: null,
    // "12" or "24". Defaults to 12-hour, which is what most of the app's
    // user-facing times already used before this setting existed.
    timeFormat: "12",
    // Company wall-clock reference, served by the API at login. Persisted so a
    // reload has it before the first request completes; null falls back to the
    // build-time env var. NOT a per-user setting — it is company-wide, and
    // lives here only because this is where the timezone plumbing already is.
    baselineTimezone: null,
  },
  mutations: {
    SET_TIMEZONE(s, p) {
      s.timezone = p || null;
    },
    SET_TIME_FORMAT(s, p) {
      s.timeFormat = p === "24" ? "24" : "12";
    },
    SET_BASELINE_TIMEZONE(s, p) {
      s.baselineTimezone = p || null;
    },
  },
  getters: {
    getTimezone: (state) => state.timezone,
    getTimeFormat: (state) => state.timeFormat,
    getBaselineTimezone: (state) => state.baselineTimezone,
  },
  actions: {
    setTimezone({ commit }, p) {
      commit("SET_TIMEZONE", p);
    },
    setTimeFormat({ commit }, p) {
      commit("SET_TIME_FORMAT", p);
    },
    // Only overwrite when the API actually sends one, so a login response from
    // an older backend cannot blank out a working value.
    setBaselineTimezone({ commit }, p) {
      if (p) commit("SET_BASELINE_TIMEZONE", p);
    },
    // Seeds the local settings from the user record returned by the API, so a
    // preference set on one machine follows the user to the next one.
    //
    // Only applies values the server actually holds, because the cached user
    // object this is called with on mount can be stale or partial — treating a
    // missing field as "no preference" there would wipe a saved setting on
    // every page load.
    hydrateFromUser({ commit }, user) {
      if (!user) return;
      if (user.timezone) commit("SET_TIMEZONE", user.timezone);
      if (user.time_format) commit("SET_TIME_FORMAT", String(user.time_format));
    },

    // Login is the account boundary, and the user record there is freshly from
    // the API, so it is authoritative: absent means this account has no
    // preference, and we fall back to the defaults.
    //
    // This has to overwrite rather than merge. The app is a SPA, so logging out
    // and back in never reloads the page: without this, whatever the previous
    // user chose survives in memory (and gets re-persisted) and the next person
    // on a shared machine inherits their timezone.
    adoptUserPreferences({ commit }, user) {
      commit("SET_TIMEZONE", (user && user.timezone) || null);
      commit("SET_TIME_FORMAT", (user && user.time_format) ? String(user.time_format) : "12");
    },
  },
};
